import { Box, Button, createStyles, makeStyles, CircularProgress } from "@material-ui/core"; // Added CircularProgress
import ArrowBackIcon from '@material-ui/icons/ArrowBack'; 
import { useEffect, useRef, useCallback, useState } from "react"; // Added useState
import { useDispatch, useSelector } from "react-redux";
import CartWindow from "./CartWindow";
import { RootState } from "../store"; 
import { BodyMeasurements, ClothingType } from "common-ts/dist/models/UserMeasurements";
import { loadMeasurementsFromLocalStorage } from "../redux/MeasurementsRedux";
import { loadAllIframeVariablesFromLocalStorage } from "../redux/CartRedux";
import { restartLoginStatus } from "../redux/AccountRedux";
import { OfflineActiveScreen, openOverlay, updateCurrentScreen } from "../redux/UIOverlayOfflineRedux";

const useStyles = makeStyles(() =>
    createStyles({
        internalShop: {
            width: "100%",
            height: "100vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "row",
        },
        iframe: {
            width: "45%",
            height: "100vh",
            border: "none",
        },
        cartContainer: {
            width: "55%",
            height: "100vh",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#ffffff",
        },
        headerContainer: {
            padding: "16px 24px",
            borderBottom: "1px solid #eeeeee",
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
        },
        backButton: {
            textTransform: "none",
            fontWeight: 600,
            color: "#424242",
            '&:hover': {
                backgroundColor: "#f5f5f5",
            }
        }
    })
);

interface Props {
    handleNext: () => void;
    activeScreen: OfflineActiveScreen;
}

export default function ProductOption({
    handleNext,
    activeScreen,
}: Props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    
    const cartHash = useSelector((state: RootState) => state.cart.cartProductListHash);
    const isFirstRun = useRef(true);

    const userSub = useSelector((state: RootState) => state.account.sub);
    const isFirstRunAccountLoad = useRef(true);

    // Loading state for back button
    const [isLoadingBack, setIsLoadingBack] = useState(false);

    // 2. CART SYNC (Child -> Parent)
    useEffect(() => {

        const handleChildMessage = (event: MessageEvent) => {
            if (event.data?.type === "SYNC_CART_FROM_CHILD") {
                dispatch(loadAllIframeVariablesFromLocalStorage());
            }
            if (event.data?.type === "RELOAD_ACCOUNT_PARENT") {
                dispatch(restartLoginStatus());
            }
            if (event.data?.type === "START_MEASUREMENT_PROCESS") {
                dispatch(updateCurrentScreen(OfflineActiveScreen.BenefitStart));
            }
        };

        window.addEventListener("message", handleChildMessage);

        return () => window.removeEventListener("message", handleChildMessage);
    }, [dispatch]);

    // 3. CART SYNC (Parent -> Child)
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        if (iframeRef.current && iframeRef.current.contentWindow) {
             setTimeout(() => {
                 iframeRef.current?.contentWindow?.postMessage({ type: "SYNC_CART_FROM_PARENT" }, "*");
             }, 100);
        }
    }, [cartHash]);

    // 3b. CART SYNC ON SCREEN ENTRY (Parent -> Child)
    // The iframe is kept mounted across the whole flow, so it does not reload
    // when we navigate into the ProductOption screen (e.g. from SizeResult).
    // Trigger a manual sync so the iframe re-reads the shared redux/localStorage
    // variables that may have changed while it was hidden.
    useEffect(() => {
        if (activeScreen !== OfflineActiveScreen.ProductOption) {
            return;
        }
        if (iframeRef.current && iframeRef.current.contentWindow) {
            setTimeout(() => {
                iframeRef.current?.contentWindow?.postMessage({ type: "SYNC_CART_FROM_PARENT" }, "*");
            }, 100);
        }
    }, [activeScreen]);

    useEffect(() => {
        if (isFirstRunAccountLoad.current) {
            isFirstRunAccountLoad.current = false;
            return;
        }
        if (iframeRef.current && iframeRef.current.contentWindow) {
            setTimeout(() => {
                iframeRef.current?.contentWindow?.postMessage({ type: "RELOAD_ACCOUNT_CHILD" }, "*");
            }, 100);
       }
    }, [userSub]);

    return (
        <Box className={classes.internalShop}>
            <iframe 
                ref={iframeRef} 
                src="/shop" 
                className={classes.iframe} 
                title="shop"
            />
            <Box className={classes.cartContainer}>
                {/* <Box className={classes.headerContainer}>
                    <Button 
                        // Conditional Icon (Hide Arrow if Loading)
                        startIcon={!isLoadingBack ? <ArrowBackIcon /> : null} 
                        className={classes.backButton}
                        disabled={isLoadingBack} // Disable on load
                        onClick={() => {
                            if (isLoadingBack) return;
                            setIsLoadingBack(true); 
                            handleBack();
                            }
                        }
                    >
                        {isLoadingBack ? <CircularProgress size={20} color="inherit" /> : "Ubah Ukuran"}
                    </Button>
                </Box> */}
                <CartWindow 
                    fullWidth={true} 
                    navState="CART" 
                    variant="inline" 
                    handleNext={handleNext} 
                />
            </Box>
        </Box>
    );
}